import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { EICFConsentsApi } from '../../../apis/EICFApi/EICFConsentsApi.ts';
import { useSessionProvider } from '../../../provider/sessionContext.tsx';

export function useGetPendingPhysicianEICFConsents(enabled: boolean = true) {
    const { currentUser } = useSessionProvider();
    const facilityId = currentUser?.selectedHealthcareFacilityID;

    return useQuery({
        queryKey: [QueryKeys.eicfPendingPhysicianConsents, facilityId],
        queryFn: () => EICFConsentsApi.getPendingForPhysician(facilityId),
        enabled,
    });
}
